import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import Modal from '../../../../common/modal'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import FileInput from '../../../../common/fileInput'
import TablePaginationCustom from '../../../../common/TablePagination'
import DropDownOA from '../../../../common/dropDownOA'
import Datepicker from '../../../../common/datePicker'
import { useDispatch } from 'react-redux'
import { getCityPairFileUploadStatus, uploadCityPairRateMatrixFileData } from '../../../../../store/generalSetting/GSAction'
import moment from 'moment'
import CityPairCancelPop from './CityPairCancelPop'
import { focusElemnt } from '../../../../common/helper'

const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}
const CityPairModal = ({ data, methods }) => {
    const dispatch = useDispatch()
    const { loginData, headText, cancelData, setCancelData, setMsg, setIsSave, cancelPop, setCancelPop } = data
    const { updateModal, updateAlertError, setShowAddNewPage } = methods
    const theme = useTheme()
    const [fileData, setFileData] = useState(null)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    const [page, setPage] = useState(0)
    const [tableData, setTableData] = useState([])
    const [reportData, setReportData] = useState([])
    const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), requestedBy: '', status: '' })
    const [requestedByList, setRequestedByList] = useState([])
    const [statusList, setStatusList] = useState([])
    // const [cancelPop, setCancelPop] = useState(false)

    const columnTable = [
        { headerName: 'S/N', field: 'sno', headerSx: { textAlign: 'right' }, },
        { headerName: 'File Name', field: 'FileName', headerSx: { textAlign: 'left' }, },
        { headerName: 'Status', field: 'Status', headerSx: { textAlign: 'left' }, },
        { headerName: 'Requested Date', field: 'InsertedDateTime', headerSx: { textAlign: 'left' }, },
        { headerName: 'Requested By', field: 'UserName', headerSx: { textAlign: 'left' }, },
        { headerName: 'Last Modified Date & Time', field: 'ModifiedDateTime', headerSx: { textAlign: 'left' }, },
        { headerName: 'Modiefied By User', field: 'CancelledUser', headerSx: { textAlign: 'left' }, },
        { headerName: 'Remark', field: 'Description', headerSx: { textAlign: 'left' }, },
        { headerName: 'Action', field: 'Action', headerSx: { textAlign: 'left' }, },
    ]

    useEffect(() => {
        getUploadTblData()
    }, [])
   
    const getUploadTblData = () => {
        let body = {
            CompanyID: loginData?.intCompanyID
        }
        dispatch(getCityPairFileUploadStatus(body)).then((res) => {
            if (res.status === 'Success') {
                if (res?.Data?.Table?.length > 0) {
                    let newData = res?.Data?.Table?.map((item, index) => ({
                        ...item,
                        srNo: index + 1,
                        RequestDate: item?.InsertedDateTime === '' || item?.InsertedDateTime === null || item?.InsertedDateTime === undefined ? '' : moment(item?.InsertedDateTime).format('HH:mm, DD-MMM-YYYY'),
                        ModifiedDate: item?.ModifiedDateTime === '' || item?.ModifiedDateTime === null || item?.ModifiedDateTime === undefined ? '' : moment(item?.ModifiedDateTime).format('HH:mm, DD-MMM-YYYY'),
                    }))
                    const uniqueRequestedByArray = Array.from(
                        new Set(newData.map(item => item.UserName)) // Extract unique names
                    ).map(UserName => {
                        // Return objects with id and name for each unique UserName
                        const firstMatchingObject = newData.find(item => item.UserName === UserName);
                        return {
                            id: firstMatchingObject.UserName,
                            name: firstMatchingObject.UserName, // You can customize this field if needed
                        };
                    });
                    uniqueRequestedByArray.unshift({ id: 'All', name: 'All' });
                    const uniqueStatusArray = Array.from(
                        new Set(newData.map(item => item.Status)) // Extract unique names
                    ).map(Status => {
                        // Return objects with id and name for each unique Status
                        const firstMatchingObject = newData.find(item => item.Status === Status);
                        return {
                            id: firstMatchingObject.Status,
                            name: firstMatchingObject.Status, // You can customize this field if needed
                        };
                    });
                    uniqueStatusArray.unshift({ id: 'All', name: 'All' });
                    setRequestedByList(uniqueRequestedByArray)
                    setStatusList(uniqueStatusArray)
                    setFilters((prev) => ({
                        ...prev,
                        requestedBy: uniqueRequestedByArray?.length > 0 ? uniqueRequestedByArray?.[0] : '',
                        status: uniqueStatusArray?.length > 0 ? uniqueStatusArray?.[0] : ''
                    }))
                    setTableData(newData)
                    setReportData(newData)
                    setFileData(null)
                } else {
                    setFileData(null)
                    setTableData([])
                    setReportData([])
                    setRequestedByList([])
                    setStatusList([])
                    setFilters((prev) => ({
                        ...prev,
                        requestedBy: '',
                        status: ''
                    }))
                }
            } else {
                dispatch(updateAlertError({ show: true, msg: res.ErrMessage, success: false, nextId: `` }))
                setTableData([])
                setReportData([])
                setRequestedByList([])
                setStatusList([])
                setFilters((prev) => ({
                    ...prev,
                    requestedBy: '',
                    status: ''
                }))
            }
        }).catch((err) => {
            dispatch(updateAlertError({ show: true, msg: err, success: false, nextId: `` }))
        })
    }
    const showCancelPopup = () => {
        const data = {
            loginData,
            headText: 'Cancellation Remarks',
            cancelData,
            setCancelData,
            getUploadTblData,
            setIsSave,
            setMsg
        }
        const methods = {
            updateModal: () => {
                setCancelPop(false)
            },
            updateAlertError,
        }
        return <CityPairCancelPop data={data} methods={methods} />
    }
    const showCancelPop = () => {
        setCancelPop(true)
    }

    const applyFilters = () => {
        const filtered = reportData.filter(row => {
            const rowDate = moment(row.InsertedDateTime);
            const from = filters?.fromDate ? moment(filters?.fromDate) : null;
            const to = filters?.toDate ? moment(filters?.toDate) : null;

            // Check if the row's date falls within the range using moment.js methods
            const isDateInRange =
                (!from || rowDate.isSameOrAfter(from, 'day')) &&
                (!to || rowDate.isSameOrBefore(to, 'day'));

            // Skip filtering by 'requestedBy' or 'status' if 'All' is selected
            const isRequestedByMatch = filters?.requestedBy?.name === 'All' || row.UserName === filters?.requestedBy?.name;
            const isStatusMatch = filters?.status?.name === 'All' || row.Status === filters?.status?.name;

            return isDateInRange && isRequestedByMatch && isStatusMatch;
        });

        // Set filtered data to tableData
        setTableData(filtered);
    };
    const handleUpload = () => {
        if (fileData === null) {
            dispatch(updateAlertError({ show: true, msg: 'Please Select A File For Uploading', success: false, nextId: `chooseFileInput` }))
        } else {
            const formData = new FormData();
            const params = {
                CompanyID: loginData?.intCompanyID,
                UserID: loginData?.intUserID
            }
            formData.append('file', fileData);
            dispatch(uploadCityPairRateMatrixFileData(params, formData)).then((res) => {
                if (res === 'Success') {
                    setMsg(`${fileData?.name}\nUploaded successfully`)
                    setIsSave(true)
                    getUploadTblData()
                } else if (res?.isSuccess === false) {
                    dispatch(updateAlertError({ show: true, msg: res?.error, success: false, nextId: `` }))
                }
            }).catch((err) => {
                dispatch(updateAlertError({ show: true, msg: err, success: false, nextId: `` }))
            })
        }
    }
    const handleCancel = (row) => {
        showCancelPop()
        setCancelData(row)
    }

    return (
        // <Modal
        //     headTxt={headText || 'Upload File'}
        //     width={'80%'}
        //     height={'auto'}
        //     updateModal={updateModal}
        //     closeId={'closeButton'}
        //     modalStyle={modalStyle}
        // >
        <>
            <div style={{ position: 'relative', height: 'calc(100% - 53px)' }}>
                <Grid container sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
                    <Grid item md={2.5}>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button
                                variant="contained"
                                id={'CityPairRatesampleBtn'}
                                color="secondary"
                                sx={{ width: '100%', fontSize: '16px' }}
                                className="receiveitembtn"
                                startIcon={<CloudDownloadIcon />}
                                onClick={() => {
                                    window.open('/SampleRateMasterCSV.xlsx', '_blank')
                                }}
                                onKeyDown={(e) => {

                                }}
                            >
                                City Pair Rate sample
                            </Button>
                        </Item>
                    </Grid>
                    <Grid item md={5}>
                        <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
                            <FileInput
                                id={'chooseFileInput'}
                                styleProps={{ width: '100%' }}
                                label={'Choose file'}
                                keepLabel={true}
                                fileChange={setFileData}
                                accept={'.xls, .xlsx'}
                                value={''}
                                onKeyDown={(e) => { }}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={1.25}>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button
                                variant="outlined"
                                color="secondary"
                                id={'uploadBtn'}
                                sx={{ width: '100%' }}
                                className="receiveitembtn"
                                startIcon={<CloudUploadIcon style={{ color: theme.palette.secondary.main }} />}
                                onClick={() => {
                                    handleUpload()
                                }}
                            >
                                UPLOAD
                            </Button>
                        </Item>
                    </Grid>
                    <Grid item md={2.75}>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button
                                variant="outlined"
                                color="secondary"
                                id={'uploadBtn'}
                                sx={{ width: '100%' }}
                                className="receiveitembtn"
                                onClick={() => {
                                    setShowAddNewPage(false)
                                }}
                            >
                                BACK TO CITY PAIR RATE MATRIX
                            </Button>
                        </Item>
                    </Grid>
                </Grid>
                <Grid container sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
                    <Grid item md={1.875}>
                        <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker" >
                            <Datepicker
                                label='From Date'
                                id={'fromDate'}
                                value={filters?.fromDate}

                                dateChange={(date) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        fromDate: date
                                    }))
                                    focusElemnt('toDate')
                                }}
                                width="100%"
                            />
                        </Item>
                    </Grid>
                    <Grid item md={1.875}>
                        <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker" >
                            <Datepicker
                                label='To Date'
                                id={'toDate'}
                                value={filters?.toDate}
                                dateChange={(date) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        toDate: date
                                    }))
                                    focusElemnt('cp-requestedBy')
                                }}
                                width="100%"
                            />
                        </Item>
                    </Grid>
                    <Grid item md={1.875}>
                        <Item sx={{ ...sx.itemsx }} className="input--container">
                            <DropDownOA
                                id={'cp-requestedBy'}
                                label={'Requested By'}
                                data={requestedByList || []}
                                defaultvalue={filters?.requestedBy?.name}
                                value={filters?.requestedBy?.name}
                                onSelect={(val) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        requestedBy: val
                                    }))
                                }}
                                onReset={() => {

                                }}
                                width={'100%'}
                                idKey={`id`}
                                dataKey={`name`}
                                nextId={`cp-status`}
                                prevId={`toDate`}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={1.875}>
                        <Item sx={{ ...sx.itemsx }} className="input--container">
                            <DropDownOA
                                id={'cp-status'}
                                label={'Status'}
                                data={statusList || []}
                                defaultvalue={filters?.status?.name}
                                value={filters?.status?.name}
                                onSelect={(val) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        status: val
                                    }))
                                }}
                                onReset={() => {

                                }}
                                width={'100%'}
                                idKey={`id`}
                                dataKey={`name`}
                                nextId={`filterBtn`}
                                prevId={`cp-requestedBy`}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={1.25}>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button
                                variant="outlined"
                                color="secondary"
                                id={'filterBtn'}
                                sx={{ width: '100%' }}
                                className="receiveitembtn"
                                onClick={() => {
                                    applyFilters()
                                }}
                            >
                                FILTER
                            </Button>
                        </Item>
                    </Grid>
                    <Grid item md={3}></Grid>
                </Grid>
                <Box sx={{ padding: '12px 15px 4px 15px' }}>
                    <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '45vh' }}>
                        <Table
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                            sx={{
                                '&.MuiTableCell-root': {
                                    padding: '6px 8px!important',
                                },
                            }}
                        >
                            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                                <TableRow>
                                    <TableCell colSpan={columnTable?.length} sx={{
                                        backgroundColor: '#BFE1FF',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                        height: '36px'
                                    }}>
                                        City Pair Rate Matrix
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    {columnTable?.map((col, index) => (
                                        <TableCell key={`CityHeader-${index}`} sx={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#444',
                                            height: '36px'
                                        }}>
                                            {col.headerName}
                                        </TableCell>
                                    ))}

                                </TableRow>
                            </TableHead>
                            {tableData?.length > 0 ? <TableBody>
                                {(
                                    rowsPerPage > 0
                                        ? tableData.slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        : tableData
                                ).map((val, index) => (
                                    <TableRow>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', textAlign: 'right' }}>
                                            {val?.srNo}
                                        </TableCell>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', }}>
                                            {val?.FileName}
                                        </TableCell>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', }}>
                                            <span style={{
                                                backgroundColor: val?.Status === 'Pending' ? '#FFFDAFCC' : val?.Status === 'Updated Successfully' ? '#1FD34266' : val?.Status === 'Cancelled' ? '#F0592466' : '#F4433699',
                                                padding: '6px', borderRadius: '20px', height: '22px'
                                            }}>
                                                {val?.Status}
                                            </span>
                                        </TableCell>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', }}>
                                            {val?.RequestDate}
                                        </TableCell>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', }}>
                                            {val?.UserName}
                                        </TableCell>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', }}>
                                            {val?.ModifiedDate}
                                        </TableCell>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', }}>
                                            {val?.CancelledUser}
                                        </TableCell>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', }}>
                                            {val?.Description}
                                        </TableCell>
                                        <TableCell sx={{ height: '36px', fontSize: '12px', fontWeight: '500', color: '#444', }}>
                                            <Button
                                                onClick={() => { handleCancel(val) }}
                                                disabled={val?.Status !== 'Pending'}
                                                sx={{ padding: 0 }}>
                                                <span style={{ padding: '4px 4px 0px 4px' }}>
                                                    <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.1214 12.1482L8.88477 10.9057L7.6481 12.1482L6.8256 11.3198L8.06227 10.0832L6.8256 8.8465L7.6481 8.024L8.88477 9.26067L10.1214 8.024L10.9498 8.8465L9.70726 10.0832L10.9498 11.3198L10.1214 12.1482ZM5.9681 0.166504H1.30143C0.653932 0.166504 0.134766 0.685671 0.134766 1.33317V10.6665C0.134766 11.314 0.653932 11.8332 1.30143 11.8332H5.85727C5.5481 11.3023 5.38477 10.6957 5.38477 10.0832C5.38477 8.15234 6.95393 6.58317 8.88477 6.58317C9.0831 6.58317 9.2756 6.60067 9.4681 6.62984V3.6665L5.9681 0.166504ZM5.38477 4.24984V1.0415L8.5931 4.24984H5.38477Z" fill="#0086FF" />
                                                    </svg>
                                                </span>

                                                Cancel</Button>

                                        </TableCell>
                                    </TableRow>

                                ))}
                            </TableBody> :
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={columnTable?.length}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>No Results Found For The Selected Filters.</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                    </TableContainer>
                    <Box sx={{
                        'svg': {
                            color: 'inherit !important'
                        }
                    }}>
                        <TablePaginationCustom totRowCount={tableData.length} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                            setPage(newPage)
                        }} handleChangeRowsPerPage={(event) => {
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0);
                        }} />
                    </Box>
                   
                </Box>
            </div>
            {cancelPop ? showCancelPopup() : null}
        </>
        // </Modal>

    )
}

export default CityPairModal